// react
import React, { useState, useEffect, useContext, useRef } from 'react';
import useForm from 'react-hook-form';

// react component for creating dynamic tables
import ReactTable from "react-table";
import { useTranslation } from 'react-i18next';

//graph
import LineGraph from '../../../beaktMatriz/views/Dashboard/Graficos/LineGraph';

// @material-ui/core | components 
import { makeStyles } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";

// icons | @material-ui/icons
import Assignment from "@material-ui/icons/Assignment";

// core components
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import Button from "beaktShared/components/CustomButtons/Button.js";
import Card from "beaktShared/components/Card/Card.js";
import CardBody from "beaktShared/components/Card/CardBody.js";
import CardIcon from "beaktShared/components/Card/CardIcon.js";
import CardHeader from "beaktShared/components/Card/CardHeader.js";
import CircularProgress from '@material-ui/core/CircularProgress';
import { useReactToPrint } from 'react-to-print';

// services
import { SessionContext } from "beaktShared/services/session";
import { useGetApi, UseGetApiSimple } from "beaktShared/services/crudeApiService";
import { transformValueFloattoFormated } from "beaktShared/helpers/masks";

// styles
import styles from "assets/jss/material-dashboard-pro-react/views/crudeStyle.js";
import stylesPrint from "assets/jss/BeaktClinic/views/Venda/contratoVenda.js";

// images
import logoDrDiabetes from 'assets/img/logoDrDiabetes.png';

const useStyles = makeStyles(styles);
const useStylesPrint = makeStyles(stylesPrint);

export default function GestaoProntuarioForm({ item, handleView }) {
    const { t } = useTranslation();
    const { register, handleSubmit, setValue, errors } = useForm({ mode: "onChange" });
    const classes = useStyles();
    const classesPrint = useStylesPrint();
    const session = useContext(SessionContext);
    const endPoint = "prontuario/";

    // Valores iniciais
    const intialValues = {
        clienteId: 0,
        clienteNome: '',
        clienteEmail: '',
    };

    const [clienteNome, setClienteNome] = React.useState('');
    const [clienteCPF, setClienteCPF] = React.useState('');
    const [clienteEmail, setClienteEmail] = React.useState('');
    const [clienteCelular, setClienteCelular] = React.useState('');

    useEffect(() => {
        if (!item.clienteId) {
            return;
        }
        else {
            setValue('clienteId', item.clienteId);
            setClienteNome(item.clienteNome);
            setClienteCPF(item.clienteCPF);
            setClienteEmail(item.clienteEmail);
            setClienteCelular(item.clienteCelular);

            let endPointGet = endPoint + "bycliente/" + item.clienteId;
            UseGetApiSimple(endPointGet, 0).then(result => {
                if (result.status == 200) {
                    loadProntuario(result.data);
                }
            });

        }
    }, [item]);

    const [loadingGlicose, setloadingGlicose] = React.useState(false);
    const [glicose, setGlicose] = React.useState([]);
    const [ultGlicose, setUltGlicose] = React.useState('');

    const [loadingHemoglobinaGlicada, setloadingHemoglobinaGlicada] = React.useState(false);
    const [hemoglobinaGlicada, setHemoglobinaGlicada] = React.useState([]);
    const [ultHemoglobinaGlicada, setUltHemoglobinaGlicada] = React.useState('');

    const [loadingInsulina, setloadingInsulina] = React.useState(false);
    const [insulina, setInsulina] = React.useState([]);
    const [ultInsulina, setUltInsulina] = React.useState('');

    const [loadingPeptideoCalculo, setloadingPeptideoCalculo] = React.useState(false);
    const [peptideoCalculo, setPeptideoCalculo] = React.useState([]);
    const [ultPeptideoCalculo, setUltPeptideoCalculo] = React.useState('');

    const [loadingPerfilLipidico, setloadingPerfilLipidico] = React.useState(false);
    const [perfilLipidico, setPerfilLipidico] = React.useState([]);
    const [ultPerfilLipidico, setUltPerfilLipidico] = React.useState('');

    const [loadingUreia, setloadingUreia] = React.useState(false);
    const [ureia, setUreia] = React.useState([]);
    const [ultUreia, setUltUreia] = React.useState('');

    const [loadingCreatinina, setloadingCreatinina] = React.useState(false);
    const [creatinina, setCreatinina] = React.useState([]);
    const [ultCreatinina, setUltCreatinina] = React.useState('');

    const [loadingTGO, setloadingTGO] = React.useState(false);
    const [TGO, setTGO] = React.useState([]);
    const [ultTGO, setUltTGO] = React.useState('');

    const [loadingTGP, setloadingTGP] = React.useState(false);
    const [TGP, setTGP] = React.useState([]);
    const [ultTGP, setUltTGP] = React.useState('');

    const [loadingEvolucaoDeVO2, setloadingEvolucaoDeVO2] = React.useState(false);
    const [evolucaoDeVO2, setEvolucaoDeVO2] = React.useState([]);
    const [ultEvolucaoDeVO2, setUltEvolucaoDeVO2] = React.useState('');

    const [loadingVitaminaD, setloadingVitaminaD] = React.useState(false);
    const [vitaminaD, setVitaminaD] = React.useState([]);
    const [ultVitaminaD, setUltVitaminaD] = React.useState('');

    const [loadingTriglicerideos, setloadingTriglicerideos] = React.useState(false);
    const [triglicerideos, setTriglicerideos] = React.useState([]);
    const [ultTriglicerideos, setUltTriglicerideos] = React.useState('');

    const [loadingG6PD, setloadingG6PD] = React.useState(false);
    const [g6PD, setG6PD] = React.useState([]);
    const [ultG6PD, setUltG6PD] = React.useState('');

    const [loadingMassaMagra, setloadingMassaMagra] = React.useState(false);
    const [massaMagra, setMassaMagra] = React.useState([]);
    const [ultMassaMagra, setUltMassaMagra] = React.useState('');

    const [loadingHDL, setloadingHDL] = React.useState(false);
    const [hdl, setHDL] = React.useState([]);
    const [ultHDL, setUltHDL] = React.useState('');

    const [loadingLDL, setloadingLDL] = React.useState(false);
    const [ldl, setLDL] = React.useState([]);
    const [ultLDL, setUltLDL] = React.useState('');

    const [loadingHomaIR, setloadingHomaIR] = React.useState(false);
    const [homaIR, setHomaIR] = React.useState([]);
    const [ultHomaIR, setUltHomaIR] = React.useState('');

    const [loadingGorduraVisceral, setloadingGorduraVisceral] = React.useState(false);
    const [gorduraVisceral, setGorduraVisceral] = React.useState([]);
    const [ultGorduraVisceral, setUltGorduraVisceral] = React.useState('');

    const [loadingVO2Absoluto, setloadingVO2Absoluto] = React.useState(false);
    const [vO2Absoluto, setVO2Absoluto] = React.useState([]);
    const [ultVO2Absoluto, setUltVO2Absoluto] = React.useState('');

    const loadProntuario = (dados) => {

        // Glicose
        setloadingGlicose(true);
        if (dados.graficoGlicose.length > 0) {
            var vIndice = dados.graficoGlicose.length - 1;
            var vUltimo = dados.graficoGlicose[vIndice].data.length - 1;
            var vData = dados.graficoGlicose[vIndice].data[vUltimo].x;
            var vValor = dados.graficoGlicose[vIndice].data[vUltimo].y;
            setUltGlicose('(Ultima data: ' + vData + ' | Valor: ' + vValor.replace('.', '|').replace(',', '.').replace('|', ',') + ')');
            setGlicose(dados.graficoGlicose);
        }
        setloadingGlicose(false);

        // HemoglobinaGlicada
        setloadingHemoglobinaGlicada(true);
        if (dados.graficoHemoglobinaGlicada.length > 0) {
            var vIndice = dados.graficoHemoglobinaGlicada.length - 1;
            var vUltimo = dados.graficoHemoglobinaGlicada[vIndice].data.length - 1;
            var vData = dados.graficoHemoglobinaGlicada[vIndice].data[vUltimo].x;
            var vValor = dados.graficoHemoglobinaGlicada[vIndice].data[vUltimo].y;
            setUltHemoglobinaGlicada('(Ultima data: ' + vData + ' | Valor: ' + vValor.replace('.', '|').replace(',', '.').replace('|', ',') + ')');
            setHemoglobinaGlicada(dados.graficoHemoglobinaGlicada);
        }
        setloadingHemoglobinaGlicada(false);

        // Insulina
        setloadingInsulina(true);
        if (dados.graficoInsulina.length > 0) {
            var vIndice = dados.graficoInsulina.length - 1;
            var vUltimo = dados.graficoInsulina[vIndice].data.length - 1;
            var vData = dados.graficoInsulina[vIndice].data[vUltimo].x;
            var vValor = dados.graficoInsulina[vIndice].data[vUltimo].y;
            setUltInsulina('(Ultima data: ' + vData + ' | Valor: ' + vValor.replace('.', '|').replace(',', '.').replace('|', ',') + ')');
            setInsulina(dados.graficoInsulina);
        }
        setloadingInsulina(false);

        // Peptídeo Calculo
        setloadingPeptideoCalculo(true);
        if (dados.graficoPeptideoCalculo.length > 0) {
            var vIndice = dados.graficoPeptideoCalculo.length - 1;
            var vUltimo = dados.graficoPeptideoCalculo[vIndice].data.length - 1;
            var vData = dados.graficoPeptideoCalculo[vIndice].data[vUltimo].x;
            var vValor = dados.graficoPeptideoCalculo[vIndice].data[vUltimo].y;
            setUltPeptideoCalculo('(Ultima data: ' + vData + ' | Valor: ' + vValor.replace('.', '|').replace(',', '.').replace('|', ',') + ')');
            setPeptideoCalculo(dados.graficoPeptideoCalculo);
        }
        setloadingPeptideoCalculo(false);

        // Perfil Lipídico
        setloadingPerfilLipidico(true);
        if (dados.graficoPerfilLipidico.length > 0) {
            var vIndice = dados.graficoPerfilLipidico.length - 1;
            var vUltimo = dados.graficoPerfilLipidico[vIndice].data.length - 1;
            var vData = dados.graficoPerfilLipidico[vIndice].data[vUltimo].x;
            var vValor = dados.graficoPerfilLipidico[vIndice].data[vUltimo].y;
            setUltPerfilLipidico('(Ultima data: ' + vData + ' | Valor: ' + vValor.replace('.', '|').replace(',', '.').replace('|', ',') + ')');
            setPerfilLipidico(dados.graficoPerfilLipidico);
        }
        setloadingPerfilLipidico(false);

        // Ureia
        setloadingUreia(true);
        if (dados.graficoUreia.length > 0) {
            var vIndice = dados.graficoUreia.length - 1;
            var vUltimo = dados.graficoUreia[vIndice].data.length - 1;
            var vData = dados.graficoUreia[vIndice].data[vUltimo].x;
            var vValor = dados.graficoUreia[vIndice].data[vUltimo].y;
            setUltUreia('(Ultima data: ' + vData + ' | Valor: ' + vValor.replace('.', '|').replace(',', '.').replace('|', ',') + ')');
            setUreia(dados.graficoUreia);
        }
        setloadingUreia(false);

        // Creatinina
        setloadingCreatinina(true);
        if (dados.graficoCreatinina.length > 0) {
            var vIndice = dados.graficoCreatinina.length - 1;
            var vUltimo = dados.graficoCreatinina[vIndice].data.length - 1;
            var vData = dados.graficoCreatinina[vIndice].data[vUltimo].x;
            var vValor = dados.graficoCreatinina[vIndice].data[vUltimo].y;
            setUltCreatinina('(Ultima data: ' + vData + ' | Valor: ' + vValor.replace('.', '|').replace(',', '.').replace('|', ',') + ')');
            setCreatinina(dados.graficoCreatinina);
        }
        setloadingCreatinina(false);

        // TGO
        setloadingTGO(true);
        if (dados.graficoTGO.length > 0) {
            var vIndice = dados.graficoTGO.length - 1;
            var vUltimo = dados.graficoTGO[vIndice].data.length - 1;
            var vData = dados.graficoTGO[vIndice].data[vUltimo].x;
            var vValor = dados.graficoTGO[vIndice].data[vUltimo].y;
            setUltTGO('(Ultima data: ' + vData + ' | Valor: ' + vValor.replace('.', '|').replace(',', '.').replace('|', ',') + ')');
            setTGO(dados.graficoTGO);
        }
        setloadingTGO(false);

        // TGP
        setloadingTGO(true);
        if (dados.graficoTGP.length > 0) {
            var vIndice = dados.graficoTGP.length - 1;
            var vUltimo = dados.graficoTGP[vIndice].data.length - 1;
            var vData = dados.graficoTGP[vIndice].data[vUltimo].x;
            var vValor = dados.graficoTGP[vIndice].data[vUltimo].y;
            setUltTGP('(Ultima data: ' + vData + ' | Valor: ' + vValor.replace('.', '|').replace(',', '.').replace('|', ',') + ')');
            setTGP(dados.graficoTGP);
        }
        setloadingTGO(false);

        // EvolucaoDeVO2
        setloadingEvolucaoDeVO2(true);
        if (dados.graficoEvolucaoDeVO2.length > 0) {
            var vIndice = dados.graficoEvolucaoDeVO2.length - 1;
            var vUltimo = dados.graficoEvolucaoDeVO2[vIndice].data.length - 1;
            var vData = dados.graficoEvolucaoDeVO2[vIndice].data[vUltimo].x;
            var vValor = dados.graficoEvolucaoDeVO2[vIndice].data[vUltimo].y;
            setUltEvolucaoDeVO2('(Ultima data: ' + vData + ' | Valor: ' + vValor.replace('.', '|').replace(',', '.').replace('|', ',') + ')');
            setEvolucaoDeVO2(dados.graficoEvolucaoDeVO2);
        }
        setloadingEvolucaoDeVO2(false);


        // Vitamina D
        setloadingVitaminaD(true);
        if (dados.graficoVitaminaD.length > 0) {
            var vIndice = dados.graficoVitaminaD.length - 1;
            var vUltimo = dados.graficoVitaminaD[vIndice].data.length - 1;
            var vData = dados.graficoVitaminaD[vIndice].data[vUltimo].x;
            var vValor = dados.graficoVitaminaD[vIndice].data[vUltimo].y;
            setUltVitaminaD('(Ultima data: ' + vData + ' | Valor: ' + vValor.replace('.', '|').replace(',', '.').replace('|', ',') + ')');
            setVitaminaD(dados.graficoVitaminaD);
        }
        setloadingVitaminaD(false);

        // Triglicerideos
        setloadingTriglicerideos(true);
        if (dados.graficoTriglicerideos.length > 0) {
            var vIndice = dados.graficoTriglicerideos.length - 1;
            var vUltimo = dados.graficoTriglicerideos[vIndice].data.length - 1;
            var vData = dados.graficoTriglicerideos[vIndice].data[vUltimo].x;
            var vValor = dados.graficoTriglicerideos[vIndice].data[vUltimo].y;
            setUltTriglicerideos('(Ultima data: ' + vData + ' | Valor: ' + vValor.replace('.', '|').replace(',', '.').replace('|', ',') + ')');
            setTriglicerideos(dados.graficoTriglicerideos);
        }
        setloadingTriglicerideos(false);

        // Massa Magra
        setloadingMassaMagra(true);
        if (dados.graficoMassaMagra.length > 0) {
            var vIndice = dados.graficoMassaMagra.length - 1;
            var vUltimo = dados.graficoMassaMagra[vIndice].data.length - 1;
            var vData = dados.graficoMassaMagra[vIndice].data[vUltimo].x;
            var vValor = dados.graficoMassaMagra[vIndice].data[vUltimo].y;
            setUltMassaMagra('(Ultima data: ' + vData + ' | Valor: ' + vValor.replace('.', '|').replace(',', '.').replace('|', ',') + ')');
            setMassaMagra(dados.graficoMassaMagra);
        }
        setloadingMassaMagra(false);

        // G6PD
        setloadingG6PD(true);
        if (dados.graficoG6PD.length > 0) {
            var vIndice = dados.graficoG6PD.length - 1;
            var vUltimo = dados.graficoG6PD[vIndice].data.length - 1;
            var vData = dados.graficoG6PD[vIndice].data[vUltimo].x;
            var vValor = dados.graficoG6PD[vIndice].data[vUltimo].y;
            setUltG6PD('(Ultima data: ' + vData + ' | Valor: ' + vValor.replace('.', '|').replace(',', '.').replace('|', ',') + ')');
            setG6PD(dados.graficoG6PD);
        }
        setloadingG6PD(false);

        // HDL
        setloadingHDL(true);
        if (dados.graficoHDL.length > 0) {
            var vIndice = dados.graficoHDL.length - 1;
            var vUltimo = dados.graficoHDL[vIndice].data.length - 1;
            var vData = dados.graficoHDL[vIndice].data[vUltimo].x;
            var vValor = dados.graficoHDL[vIndice].data[vUltimo].y;
            setUltHDL('(Ultima data: ' + vData + ' | Valor: ' + vValor.replace('.', '|').replace(',', '.').replace('|', ',') + ')');
            setHDL(dados.graficoHDL);
        }
        setloadingHDL(false);

        // LDL
        setloadingLDL(true);
        if (dados.graficoLDL.length > 0) {
            var vIndice = dados.graficoLDL.length - 1;
            var vUltimo = dados.graficoLDL[vIndice].data.length - 1;
            var vData = dados.graficoLDL[vIndice].data[vUltimo].x;
            var vValor = dados.graficoLDL[vIndice].data[vUltimo].y;
            setUltLDL('(Ultima data: ' + vData + ' | Valor: ' + vValor.replace('.', '|').replace(',', '.').replace('|', ',') + ')');
            setLDL(dados.graficoLDL);
        }
        setloadingLDL(false);

        // HomaIR
        setloadingHomaIR(true);
        if (dados.graficoHomaIR.length > 0) {
            var vIndice = dados.graficoHomaIR.length - 1;
            var vUltimo = dados.graficoHomaIR[vIndice].data.length - 1;
            var vData = dados.graficoHomaIR[vIndice].data[vUltimo].x;
            var vValor = dados.graficoHomaIR[vIndice].data[vUltimo].y;
            setUltHomaIR('(Ultima data: ' + vData + ' | Valor: ' + vValor.replace('.', '|').replace(',', '.').replace('|', ',') + ')');
            setHomaIR(dados.graficoHomaIR);
        }
        setloadingHomaIR(false);

        // Gordura Visceral
        setloadingGorduraVisceral(true);
        if (dados.graficoGorduraVisceral.length > 0) {
            var vIndice = dados.graficoGorduraVisceral.length - 1;
            var vUltimo = dados.graficoGorduraVisceral[vIndice].data.length - 1;
            var vData = dados.graficoGorduraVisceral[vIndice].data[vUltimo].x;
            var vValor = dados.graficoGorduraVisceral[vIndice].data[vUltimo].y;
            setUltGorduraVisceral('(Ultima data: ' + vData + ' | Valor: ' + vValor.replace('.', '|').replace(',', '.').replace('|', ',') + ')');
            setGorduraVisceral(dados.graficoGorduraVisceral);
        }
        setloadingGorduraVisceral(false);

        // VO2 Absoluto
        setloadingVO2Absoluto(true);
        if (dados.graficoVO2Absoluto.length > 0) {
            var vIndice = dados.graficoVO2Absoluto.length - 1;
            var vUltimo = dados.graficoVO2Absoluto[vIndice].data.length - 1;
            var vData = dados.graficoVO2Absoluto[vIndice].data[vUltimo].x;
            var vValor = dados.graficoVO2Absoluto[vIndice].data[vUltimo].y;
            setUltVO2Absoluto('(Ultima data: ' + vData + ' | Valor: ' + vValor.replace('.', '|').replace(',', '.').replace('|', ',') + ')');
            setVO2Absoluto(dados.graficoVO2Absoluto);
        }
        setloadingVO2Absoluto(false);
    }

    //Função Imprimir
    const refImprimir = useRef();
    const handlePrint = useReactToPrint({
        content: () => refImprimir.current,
        copyStyles: true,
        documentTitle: "",
    });

    const handleCustomPrint = () => {
        handlePrint();
        document.title = "BeaktProntuario";
    };

    const handleViewForm = () => {
        handleView(false);
    };

    return (
        <>
            <div className="no-print">
                <div style={{ textAlign: 'center' }}>
                    <div>
                        <Button onClick={() => handleViewForm()} color="#efefef" className={classes.updateProfileButton}>
                            {t('label.return')}
                        </Button>
                        <Button color="info" onClick={handleCustomPrint}>
                            {t('button.print')}
                        </Button>
                    </div>
                </div>
            </div>

            <GridContainer>
                <GridItem xs={12}>
                    <Card>
                        <CardHeader color="primary" icon>
                            <CardIcon color="primary">
                                <Assignment />
                            </CardIcon>
                            <h4 className={classes.cardIconTitle}>{t('label.evolution_medical_record')}</h4>
                        </CardHeader>
                        <CardBody>

                            <div
                                id="div_Resultado"
                                ref={refImprimir}
                                className="allowPrint"
                                style={{ color: 'black', maxWidth: '900px', margin: '0 auto', border: '1px solid rgb(206, 206, 206)', background: 'white', padding: '20px 30px', fontWeight: '400' }}
                            >

                                <table style={{ width: '100%', textAlign: 'center' }}>
                                    <thead>
                                        <tr>
                                            <th>

                                                <div style={{ borderTop: 'solid 1px black', borderBottom: 'solid 1px black' }}>
                                                    <GridContainer className={classes.boxAvaliacao} alignItems={'center'} style={{ margin: '10px 0' }}>
                                                        <GridItem xs={6} md={6} style={{ paddingLeft: '20px', borderRight: 'solid 1px black' }}>
                                                            <div style={{ textAlign: 'center' }}>
                                                                <img src={logoDrDiabetes} style={{ maxWidth: '380px' }} />
                                                            </div>
                                                        </GridItem>
                                                        <GridItem xs={3} md={3} style={{ textAlign: 'center' }}>
                                                            UNIDADE: <strong>{session.estabelecimentoDescricao}</strong>
                                                        </GridItem>
                                                    </GridContainer>
                                                </div>

                                                <GridContainer className={classes.boxAvaliacao} alignItems={'center'} style={{ margin: '10px 0' }}>
                                                    <GridItem xs={4} md={4} style={{ paddingLeft: '20px' }}>
                                                        <div style={{ textAlign: 'center' }}>
                                                            <h3 className={classes.titleStep}>{t('label.client_medical_record')}: </h3>
                                                        </div>
                                                    </GridItem>
                                                    <GridItem xs={8} md={8} style={{ textAlign: 'center', padding: '0 10px' }}>
                                                        <p style={{ margin: '0', padding: '0' }}>
                                                            <strong>{clienteNome}</strong>
                                                        </p>
                                                        <p style={{ margin: '0', padding: '0' }}>
                                                            <strong> CPF: </strong> {clienteCPF} |
                                                            <strong> Celular: </strong> {clienteCelular} |
                                                            <strong> E-mail: </strong>{clienteEmail}
                                                        </p>
                                                    </GridItem>
                                                </GridContainer>

                                                <hr className="linha" />

                                            </th>
                                        </tr>
                                    </thead>

                                    <tbody>

                                        <div style={{ textAlign: 'center' }}>
                                            <GridContainer>
                                                <GridItem xs={12} md={12}>

                                                    <h4 className={classes.titleBold}>
                                                        Glicose <span className={classes.textInfo}>{ultGlicose}</span>
                                                    </h4>
                                                    <div style={{ height: '250px' }}>
                                                        {loadingGlicose &&
                                                            <div className="loadingDash">
                                                                <CircularProgress size={40} />
                                                            </div>
                                                        }
                                                        {!loadingGlicose &&
                                                            <LineGraph data={glicose} />
                                                        }
                                                    </div>
                                                </GridItem>
                                            </GridContainer>

                                            <hr className="linha" />

                                            <GridContainer>
                                                <GridItem xs={12} md={12}>
                                                    <h4 className={classes.titleBold}>
                                                        Hemoglobina Glicada <span className={classes.textInfo}>{ultHemoglobinaGlicada}</span>
                                                    </h4>
                                                    <div style={{ height: '250px' }}>
                                                        {loadingHemoglobinaGlicada &&
                                                            <div className="loadingDash">
                                                                <CircularProgress size={40} />
                                                            </div>
                                                        }
                                                        {!loadingHemoglobinaGlicada &&
                                                            <LineGraph data={hemoglobinaGlicada} />
                                                        }
                                                    </div>
                                                </GridItem>
                                            </GridContainer>

                                            <hr className="linha" />

                                            <GridContainer>
                                                <GridItem xs={12} md={12}>
                                                    <h4 className={classes.titleBold}>
                                                        Insulina <span className={classes.textInfo}>{ultInsulina}</span>
                                                    </h4>
                                                    <div style={{ height: '250px' }}>
                                                        {loadingInsulina &&
                                                            <div className="loadingDash">
                                                                <CircularProgress size={40} />
                                                            </div>
                                                        }
                                                        {!loadingInsulina &&
                                                            <LineGraph data={insulina} />
                                                        }
                                                    </div>
                                                </GridItem>
                                            </GridContainer>

                                            <hr className="linha" />

                                            <GridContainer>
                                                <GridItem xs={12} md={12}>
                                                    <h4 className={classes.titleBold}>
                                                        Peptídeo Calculo <span className={classes.textInfo}>{ultPeptideoCalculo}</span>
                                                    </h4>
                                                    <div style={{ height: '250px' }}>
                                                        {loadingPeptideoCalculo &&
                                                            <div className="loadingDash">
                                                                <CircularProgress size={40} />
                                                            </div>
                                                        }
                                                        {!loadingPeptideoCalculo &&
                                                            <LineGraph data={peptideoCalculo} />
                                                        }
                                                    </div>
                                                </GridItem>
                                            </GridContainer>

                                            <hr className="linha" />

                                            {/* <GridContainer className={classesPrint.pageBreak}>
                                                <GridItem xs={12} md={12}>
                                                    <h4 className={classes.titleBold}>
                                                        Perfil Lipídico <span className={classes.textInfo}>{ultPerfilLipidico}</span>
                                                    </h4>
                                                    <div style={{ height: '250px' }}>
                                                        {loadingPerfilLipidico &&
                                                            <div className="loadingDash">
                                                                <CircularProgress size={40} />
                                                            </div>
                                                        }
                                                        {!loadingPerfilLipidico &&
                                                            <LineGraph data={perfilLipidico} />
                                                        }
                                                    </div>
                                                </GridItem>
                                            </GridContainer>

                                            <hr className="linha" /> */}

                                            <GridContainer>
                                                <GridItem xs={12} md={12}>
                                                    <h4 className={classes.titleBold}>
                                                        Ureia <span className={classes.textInfo}>{ultUreia}</span>
                                                    </h4>
                                                    <div style={{ height: '250px' }}>
                                                        {loadingUreia &&
                                                            <div className="loadingDash">
                                                                <CircularProgress size={40} />
                                                            </div>
                                                        }
                                                        {!loadingUreia &&
                                                            <LineGraph data={ureia} />
                                                        }
                                                    </div>
                                                </GridItem>
                                            </GridContainer>

                                            <hr className="linha" />

                                            <GridContainer>
                                                <GridItem xs={12} md={12}>
                                                    <h4 className={classes.titleBold}>
                                                        Creatinina <span className={classes.textInfo}>{ultCreatinina}</span>
                                                    </h4>
                                                    <div style={{ height: '250px' }}>
                                                        {loadingCreatinina &&
                                                            <div className="loadingDash">
                                                                <CircularProgress size={40} />
                                                            </div>
                                                        }
                                                        {!loadingCreatinina &&
                                                            <LineGraph data={creatinina} />
                                                        }
                                                    </div>
                                                </GridItem>
                                            </GridContainer>

                                            <hr className="linha" />

                                            <GridContainer>
                                                <GridItem xs={12} md={12}>
                                                    <h4 className={classes.titleBold}>
                                                        TGO <span className={classes.textInfo}>{ultTGO}</span>
                                                    </h4>
                                                    <div style={{ height: '250px' }}>
                                                        {loadingTGO &&
                                                            <div className="loadingDash">
                                                                <CircularProgress size={40} />
                                                            </div>
                                                        }
                                                        {!loadingTGO &&
                                                            <LineGraph data={TGO} />
                                                        }
                                                    </div>
                                                </GridItem>
                                            </GridContainer>

                                            <hr className="linha" />

                                            <GridContainer className={classesPrint.pageBreak}>
                                                <GridItem xs={12} md={12}>
                                                    <h4 className={classes.titleBold}>
                                                        TGP <span className={classes.textInfo}>{ultTGP}</span>
                                                    </h4>
                                                    <div style={{ height: '250px' }}>
                                                        {loadingTGP &&
                                                            <div className="loadingDash">
                                                                <CircularProgress size={40} />
                                                            </div>
                                                        }
                                                        {!loadingTGP &&
                                                            <LineGraph data={TGP} />
                                                        }
                                                    </div>
                                                </GridItem>
                                            </GridContainer>

                                            <hr className="linha" />

                                            <GridContainer>
                                                <GridItem xs={12} md={12}>
                                                    <h4 className={classes.titleBold}>
                                                        Evolução de AMOx <span className={classes.textInfo}>{ultEvolucaoDeVO2}</span>
                                                    </h4>
                                                    <div style={{ height: '250px' }}>
                                                        {loadingEvolucaoDeVO2 &&
                                                            <div className="loadingDash">
                                                                <CircularProgress size={40} />
                                                            </div>
                                                        }
                                                        {!loadingEvolucaoDeVO2 &&
                                                            <LineGraph data={evolucaoDeVO2} />
                                                        }
                                                    </div>
                                                </GridItem>
                                            </GridContainer>

                                            <hr className="linha" />

                                            <GridContainer>
                                                <GridItem xs={12} md={12}>
                                                    <h4 className={classes.titleBold}>
                                                        Vitamina D <span className={classes.textInfo}>{ultVitaminaD}</span>
                                                    </h4>
                                                    <div style={{ height: '250px' }}>
                                                        {loadingVitaminaD &&
                                                            <div className="loadingDash">
                                                                <CircularProgress size={40} />
                                                            </div>
                                                        }
                                                        {!loadingVitaminaD &&
                                                            <LineGraph data={vitaminaD} />
                                                        }
                                                    </div>
                                                </GridItem>
                                            </GridContainer>

                                            <hr className="linha" />


                                            <GridContainer>
                                                <GridItem xs={12} md={12}>
                                                    <h4 className={classes.titleBold}>
                                                        Triglicerídeos <span className={classes.textInfo}>{ultTriglicerideos}</span>
                                                    </h4>
                                                    <div style={{ height: '250px' }}>
                                                        {loadingTriglicerideos &&
                                                            <div className="loadingDash">
                                                                <CircularProgress size={40} />
                                                            </div>
                                                        }
                                                        {!loadingTriglicerideos &&
                                                            <LineGraph data={triglicerideos} />
                                                        }
                                                    </div>
                                                </GridItem>
                                            </GridContainer>

                                            <hr className="linha" />
                                            <GridContainer>
                                                <GridItem xs={12} md={12}>
                                                    <h4 className={classes.titleBold}>
                                                        Massa Magra <span className={classes.textInfo}>{ultMassaMagra}</span>
                                                    </h4>
                                                    <div style={{ height: '250px' }}>
                                                        {loadingMassaMagra &&
                                                            <div className="loadingDash">
                                                                <CircularProgress size={40} />
                                                            </div>
                                                        }
                                                        {!loadingMassaMagra &&
                                                            <LineGraph data={massaMagra} />
                                                        }
                                                    </div>
                                                </GridItem>
                                            </GridContainer>

                                            <hr className="linha" />
                                            <GridContainer>
                                                <GridItem xs={12} md={12}>
                                                    <h4 className={classes.titleBold}>
                                                        G6PD <span className={classes.textInfo}>{ultG6PD}</span>
                                                    </h4>
                                                    <div style={{ height: '250px' }}>
                                                        {loadingG6PD &&
                                                            <div className="loadingDash">
                                                                <CircularProgress size={40} />
                                                            </div>
                                                        }
                                                        {!loadingG6PD &&
                                                            <LineGraph data={g6PD} />
                                                        }
                                                    </div>
                                                </GridItem>
                                            </GridContainer>

                                            <hr className="linha" />
                                            <GridContainer>
                                                <GridItem xs={12} md={12}>
                                                    <h4 className={classes.titleBold}>
                                                        HDL <span className={classes.textInfo}>{ultHDL}</span>
                                                    </h4>
                                                    <div style={{ height: '250px' }}>
                                                        {loadingHDL &&
                                                            <div className="loadingDash">
                                                                <CircularProgress size={40} />
                                                            </div>
                                                        }
                                                        {!loadingHDL &&
                                                            <LineGraph data={hdl} />
                                                        }
                                                    </div>
                                                </GridItem>
                                            </GridContainer>

                                            <hr className="linha" />
                                            <GridContainer>
                                                <GridItem xs={12} md={12}>
                                                    <h4 className={classes.titleBold}>
                                                        LDL <span className={classes.textInfo}>{ultLDL}</span>
                                                    </h4>
                                                    <div style={{ height: '250px' }}>
                                                        {loadingLDL &&
                                                            <div className="loadingDash">
                                                                <CircularProgress size={40} />
                                                            </div>
                                                        }
                                                        {!loadingLDL &&
                                                            <LineGraph data={ldl} />
                                                        }
                                                    </div>
                                                </GridItem>
                                            </GridContainer>

                                            <hr className="linha" />
                                            <GridContainer>
                                                <GridItem xs={12} md={12}>
                                                    <h4 className={classes.titleBold}>
                                                        Homa IR <span className={classes.textInfo}>{ultHomaIR}</span>
                                                    </h4>
                                                    <div style={{ height: '250px' }}>
                                                        {loadingHomaIR &&
                                                            <div className="loadingDash">
                                                                <CircularProgress size={40} />
                                                            </div>
                                                        }
                                                        {!loadingHomaIR &&
                                                            <LineGraph data={homaIR} />
                                                        }
                                                    </div>
                                                </GridItem>
                                            </GridContainer>

                                            <hr className="linha" />
                                            <GridContainer>
                                                <GridItem xs={12} md={12}>
                                                    <h4 className={classes.titleBold}>
                                                        Gordura Visceral <span className={classes.textInfo}>{ultGorduraVisceral}</span>
                                                    </h4>
                                                    <div style={{ height: '250px' }}>
                                                        {loadingGorduraVisceral &&
                                                            <div className="loadingDash">
                                                                <CircularProgress size={40} />
                                                            </div>
                                                        }
                                                        {!loadingGorduraVisceral &&
                                                            <LineGraph data={gorduraVisceral} />
                                                        }
                                                    </div>
                                                </GridItem>
                                            </GridContainer>

                                            <hr className="linha" />
                                            <GridContainer>
                                                <GridItem xs={12} md={12}>

                                                    <h4 className={classes.titleBold}>
                                                        RCQ <span className={classes.textInfo}>{ultVO2Absoluto}</span>
                                                    </h4>
                                                    <div style={{ height: '250px' }}>
                                                        {loadingVO2Absoluto &&
                                                            <div className="loadingDash">
                                                                <CircularProgress size={40} />
                                                            </div>
                                                        }
                                                        {!loadingVO2Absoluto &&
                                                            <LineGraph data={vO2Absoluto} />
                                                        }
                                                    </div>
                                                </GridItem>
                                            </GridContainer>
                                            <hr className="linha" />
                                        </div>

                                    </tbody>
                                </table>

                            </div>

                        </CardBody>
                    </Card>
                </GridItem>
            </GridContainer>

        </>
    )
}